class importModalCtrl {
    constructor($scope, $timeout, $uibModalInstance, items1, httpRequest) {
        $scope.title = items1.title
        $scope.resultText = '尚未完成'
        if (items1.batchStatus != 2) {
            $timeout(() => {
                $scope.getInputBatchInfo(items1.batchNo)
            }, 10000)
        } else {
            $scope.resultText = `${items1.type ? items1.type : '扫描'}完成`
        }
        if (items1.remark) $scope.result = items1.remark.split(';')
        else $scope.result = false
        $scope.getInputBatchInfo = function (batchNo) {
            httpRequest.get_getInputBatchInfo({
                batchNo,
            }).then((res) => {
                console.log(res)
                $scope.title = `本次共成功${items1.type ? items1.type : '扫描'}${res.data.value.sucessCount ? res.data.value.sucessCount : 0} 张发票，${res.data.value.inputCount ? res.data.value.inputCount : 0}${res.data.value.sucessCount ? res.data.value.sucessCount : 0}张失败`
                if (res.data.value.batchStatus != 2) {
                    $timeout(() => {
                        $scope.getInputBatchInfo(res.data.value.batchNo)
                    }, 10000)
                } else {
                    $scope.resultText = `${items1.type ? items1.type : '扫描'}完成`
                }
                if (res.data.value.remark) $scope.result = res.data.value.remark.split(';')
                else $scope.result = false
            })
        }
        // 确定
        $scope.ok = function (v) {
            // 返回数据
            $uibModalInstance.close()
        }
        $scope.cancel = function (v) {
            // 返回数据
            $uibModalInstance.dismiss()
        }
    }
}

importModalCtrl.$inject = ['$scope', '$timeout', '$uibModalInstance', 'items1', 'httpRequest']
export default importModalCtrl



// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/collection/importModalCtrl.js